import React, {memo, Suspense} from "react"
import {MANIFEST} from "@manifest/plp"
import {useTemplatedComponent} from "@next/templating"
import {TextModel} from "models/Text"
import connect from "./connect"

export interface FiltersMobileTitleProps {
    templating: {mainTemplate: string; fallbackTemplate: string}
    text: TextModel
}

const FiltersMobileTitle = memo<FiltersMobileTitleProps>(function FiltersMobileTitleMemo({templating, ...props}) {
    const ComponentName = useTemplatedComponent(templating, MANIFEST)

    return (
        <Suspense>
            <ComponentName {...props} />
        </Suspense>
    )
})
FiltersMobileTitle.displayName = "FiltersMobileTitle"

export default connect(FiltersMobileTitle)
